export type OnboardingStore = {
  step: OnboardingSteps,
  index: number,
  steps: OnboardingSteps[],
};

export enum OnboardingSteps {
  AGENDAS = 'AGENDAS',
  CONNECTED = 'CONNECTED',
  NAME = 'NAME',
  LOCATION = 'LOCATION',
  RANGES = 'RANGES',
  COMPLETED = 'COMPLETED',
  CLAIMED = 'CLAIMED',
  COMPANY = 'COMPANY',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type OnboardingActionType = any;
